const sections = [
    { id: 'home', navbarTitle: 'Home', sectionTitle: '' },
    { id: 'about-me', navbarTitle: 'Chi Sono', sectionTitle: 'La mia Storia' },
    { id: 'skills', navbarTitle: 'Competenze', sectionTitle: 'Competenze Tecniche' },
    { id: 'portfolio', navbarTitle: 'Progetti', sectionTitle: 'GameDev Projects' },
    { id: 'experience', navbarTitle: 'Esperienza', sectionTitle: 'Percorso Professionale' },
    { id: 'contact-info', navbarTitle: 'Contatti' },
];

export default sections;